import { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import api from 'axios.js';
import { useToastify } from '../../../hooks/useToastify';
import { Form, Formik } from 'formik';
import { Button, Input } from 'app/components';
import * as Yup from "yup";
import { twMerge } from 'tailwind-merge';

interface ProfileFormProps { 
  onSave: () => void,
  edit: boolean,
  profileId: number | null,
  permissions: string[]
}

interface ProfileProps { 
  name: string, 
  description: string 
}

function ProfileForm({ onSave, edit, profileId, permissions }: ProfileFormProps) {
  const Toast = useToastify();

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Nome do perfil é obrigatório"),
    desctiption: Yup.string()
      .notRequired(),
  });

  const [initialValue, setInitialValue] = useState<ProfileProps>({
    name: '',
    description: ''
  });

  useEffect(() => {
    if (edit) {
      getPerfil()
    }
  },[edit]);

  const getPerfil = async () => {
    const perfil = await api.get(`/perfil/${profileId}`)

    if (perfil.status === 200) {
      setInitialValue({
        name: perfil.data.perfil.name,
        description: perfil.data.perfil.description,
      })
    }
  }

  const handleSubmit = async (data: ProfileProps) => {

    try {
      let response;

      const { name, description } = data;

      if (edit) {
        response = await api.put('/perfil', { name, description, profileId });
      } else {
        response = await api.post('/perfil', { name, description });
      }

      if (response.status === 201 || response.status === 200) {
        onSave();

        Toast.show('success', edit ? 'Perfil editado com sucesso!' : 'Perfil cadastrado com sucesso!')

        setInitialValue({
          name: '',
          description: '',
        })       

      } else {
        Toast.show('error', response.data.message)
      }
    } catch (e) {
      console.error(e)
    }
    
  };

  return (
    <div className="tw-p-6 tw-bg-white tw-shadow-md tw-rounded-lg tw-mb-4">
      <h2 className="tw-text-xl tw-font-bold tw-mb-4">Cadastro de Perfil</h2>
      <Formik
        initialValues={initialValue}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({ values, touched, errors, handleChange, setFieldValue }) => (
          <Form className="tw-flex tw-items-start tw-gap-4">
            <Input.Root className="tw-flex tw-flex-col tw-w-full">
              <Input.Label required text="Nome do Perfil" />
              <TextField
                name="name"
                placeholder="Informe o nome do Perfil"
                inputProps={{ maxLength: 100 }}
                onChange={handleChange}
                value={values.name}
                size='small'
              />
              {errors.name && (<Input.Error text={errors.name as string} />)}
            </Input.Root>
            <Input.Root className="tw-flex tw-flex-col tw-w-full">
              <Input.Label text="Descrição do Perfil" />
              <TextField
                name="description"
                placeholder="Informe a descição do Perfil"
                inputProps={{ maxLength: 150 }}
                onChange={handleChange}
                value={values.description}
                size='small'
              />
              {errors.description && (<Input.Error text={errors.description as string} />)}
            </Input.Root>
            <Button.Root>
              <Button.Element 
                type="submit"
                className={twMerge(
                  "tw-rounded-[4px] tw-h-[40px] tw-mt-[24px]", 
                  (
                    !permissions.includes('create') ||
                    (edit && !permissions.includes('edit'))
                  ) && "tw-bg-slate-400 tw-text-white tw-min-w-[200px] tw-max-w-[230px] hover:tw-cursor-not-allowed"
                )}
                disabled={!permissions.includes('create')}
                variant={!permissions.includes('create') ? 'none' : 'primary'}
              >
                  <Button.Text text='Salvar' />
              </Button.Element>
            </Button.Root>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ProfileForm;
